export default __webpack_public_path__ + "static/media/1960.a8e23bb9.png";